import CollectionsIcon from '@mui/icons-material/Collections';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import DataGrid from 'app/components/DataGrid';
import usePhotographerHourlyReport from 'app/hooks/usePhotographerHourlyReport';
import useDeeplink from 'app/hooks/useDeeplink';

import {
  moments
} from 'app/resources';

import {
  AND_OPERATOR,
} from 'app/hooks/useFilter';

import {
  getPhotographerHourlyReport
} from 'app/services/reports';

const PhotographerHourlyReport = () => {
  const header = 'Photographer Hourly Report';

  const {
    resource,
    onDataGridLoad,
    showFilters,
    getRowData,
    getFilterModel
  } = usePhotographerHourlyReport();

  const deeplink = useDeeplink();

  const exportCSV = () => {
    let params = {
      page: 1,
      per_page: 1000,
      is_export: true
    }

    const filterModel = getFilterModel();
    if (filterModel) {
      params.filter_model = filterModel;
    }

    params.selected_dropdown_filter = { key: 'PHOTOGRAPHER_HOURLY', value: 'PHOTOGRAPHER_HOURLY', label: 'Photographer Hourly Report' }

    getPhotographerHourlyReport(params).then((resp => resp.blob())).then((blob) => {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = `photographer_hourly_report_${new Date().toISOString()}.csv`;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    })
  }

  const viewMomentsForPhotog = async (user_id, hour) => {

    let start = new Date(hour);

    let end = new Date(start.getTime());
    end.setTime(end.getTime() + (1 * 60 * 60 * 1000))

    // filter moments by user_id ahead of showing the moments table.
    // this will overwrite any filters previously set.
    // currently the filter expects values to be strings
    let filterModel = {
      user_id: [{
        filterClass: 'number',
        filterType: 'equals',
        value: user_id.toString(),
        operator: AND_OPERATOR
      }],
      uploaded: [
      {
        filterClass: 'date',
        filterType: 'greaterThan',
        value: start,
        operator: AND_OPERATOR
      },
      {
        filterClass: 'date',
        filterType: 'lessThan',
        value: end,
        operator: AND_OPERATOR
      }]
    }

    deeplink.load(moments, filterModel);
  }

  const getReportColumns = () => {
    const linkStyle = {
      float: 'left',
      padding: '0.65rem',
      color: 'rgb(61, 66, 188)',
      cursor: 'pointer',
      fontWeight: 500
    };

    return [
      {
        field: 'job_id',
        headerName: 'Job ID',
        inputType: 'number',
      },
      {
        field: 'job_name',
        headerName: 'Job Name'
      },
      {
        field: 'user',
        headerName: 'User'
      },
      {
        field: 'hour',
        headerName: 'Hour',
        inputType: 'date',
        valueFormatter: data => {
          let d = new Date(data);
          return d.toLocaleString()
        },
      },
      {
        field: 'total_photos',
        headerName: 'Total Photos',
        inputType: 'number',
        cellRenderer: params => {
          let data = params.data;
          if (data) {
            const { user_id, hour, total_photos } = data;
            const onClick = () => viewMomentsForPhotog(user_id, hour);
            let count = `${total_photos || 0}`;

            return (
              <span style={linkStyle} onClick={onClick}>
                <CollectionsIcon sytle={{ marginRight: '0.5rem' }} />
                {count}
              </span>
            );
          }
          return '';
        }
      },
    ]
  }

  const columnDefOverrides = getReportColumns();
  const columnOrder = columnDefOverrides.map((column) => column.field);
  const visibleColumns = [].concat(columnOrder);

  const buttons = [
    {
      key: 'export',
      icon: <FileDownloadIcon />,
      label: 'Export CSV',
      onClick: exportCSV
    }
  ]

  return <div>
    <DataGrid
      header={header}
      resource={resource}
      defaultDropdownOption={{ key: 'PHOTOGRAPHER_HOURLY_REPORT', value: 'PHOTOGRAPHER_HOURLY_REPORT', label: 'Photographer Hourly Report' }}
      showDropDown={false}
      getRowData={getRowData}
      showFilters={showFilters}
      onDataGridLoad={onDataGridLoad}
      columnOrder={columnOrder}
      columnDefOverrides={columnDefOverrides}
      visibleColumns={visibleColumns}
      loadingMessage="Loading report..."
      buttons={buttons}
    />
  </div>
}

export default PhotographerHourlyReport;
